import React from 'react';
import PropTypes from 'prop-types';
import InvisibleInput from '../InvisibleInput';

const DayInput = ({ value, onChange, ...other }) => {
    const handleChange = e => {
        const { value } = e.target;

        if (value.length > 0 && value !== '0') {
            const result = /(^0?[1-9]$)|(^[12]\d$)|(^3[01]$)/.test(value);

            if (!result) {
                e.preventDefault();
                return;
            }
        }

        if (onChange) {
            onChange(e);
        }
    };

    return (
        <InvisibleInput
            {...other}
            name="day"
            className="onsolve-date-input__day"
            value={value}
            maxLength={2}
            onChange={handleChange}
        />
    );
};

DayInput.propTypes = {
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    value: PropTypes.string
};

DayInput.defaultProps = {
    placeholder: 'DD'
};

DayInput.displayName = 'DayInput';

export default DayInput;
